/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {

    'use strict';

    // side bar collapse
    $(document).ready(function () {
      
        // managage back button click (and backspace)
        var count = 0; // needed for safari
        window.onload = function () { 
            if (typeof history.pushState === "function") { 
                history.pushState("back", null, null);          
                window.onpopstate = function () { 
                    history.pushState('back', null, null);              
                    if(count == 1){ window.location.reload(); }
                    //if(count == 1){window.location = 'your url';}
                 }; 
             }
         }  
        setTimeout(function(){count = 1;},200);
      
        $('#sidebarCollapse').on('click', function () {
            $('#sidebar').toggleClass('active');
            $(this).toggleClass('active');
            $("body").addClass("noscroll");
            $(".closing").css('display', 'block');
            $(".side-bar-bg").css('display', 'block');
            $(window).on("resize", function (e) {
                checkScreenSize();
            });
        
            checkScreenSize();
        
            function checkScreenSize(){
                var newWindowWidth = $(window).width();
                if (newWindowWidth < 481) {
                    $(".site-content-wrap").css("cssText", "min-height: 100vh !important;");
                }
            }
        });
        $('.closing').on('click', function () {
            $('#sidebar').toggleClass('active');
            $(this).toggleClass('active');
            $("body").removeClass("noscroll");
            $(".closing").css('display', 'none');
            $(".side-bar-bg").css('display', 'none');
            $(window).on("resize", function (e) {
                checkScreenSize1();
            });
        
            checkScreenSize1();
        
            function checkScreenSize1(){
                var newWindowWidth = $(window).width();
                if (newWindowWidth < 481) {
                    $(".site-content-wrap").css("cssText", "min-height: 100%");
                }
            }
        });

        // horizontal slide
        $('.menu-croll-left').click(function () {
            $('#scrollbar1').stop().animate({
                scrollLeft: "-=100"
            });
        });
        $('.menu-croll-right').click(function () {
            $('#scrollbar1').stop().animate({
                scrollLeft: "+=100"
            });
        });
    
        if ($('.menu li.active').length) {
            $('#scrollbar1').scrollLeft($('.menu li.active').offset().left - $('#scrollbar1').offset().left);
        }
        showControls();
        //Controls for menu
        function showControls() {
            var menuLength = 0;
            $('.menu li').each(function () {
                menuLength = menuLength + $(this).width();
            });
            if ($('#scrollbar1').width() < menuLength) {
                $('.menu-croll-right, .menu-croll-left').show();
            } else {
                $('.menu-croll-right, .menu-croll-left').hide();
            }
        }
    
        //Initiate window resize function
        $(window).resize(function () {
            showControls();
        });
        // $('.sidebarmenu li').click(function(){
        //     console.log('click');
        //     $(this).addClass('active').siblings().removeClass('active');
        // });
    });
    
    //select all checkboxes
    $("#select_all_docs").change(function () {  //"select all" change 
        $(".file_check").prop('checked', $(this).prop("checked")); //change all ".checkbox" checked status
        $(".file_check").trigger("change");
    });

    $(".file_check").change(function () {
        if (false === $(this).prop("checked")) { //if this item is unchecked
            $("#select_all_docs").prop('checked', false); //change "select all" checked status to false
        }

        //check "select all" if all checkbox items are checked
        if (jQuery('.file_check:checked').length === jQuery('.file_check').length) {
            jQuery("#select_all_docs").prop('checked', true);
        }

        var counter = 0;
        $('.file_check').each(function () {
            if ($(this).prop("checked")) {
                counter++;
            }
        });
        $(".total_file_selected").text(counter + " file selected ");
        if (counter > 0) {
            $(".download_all_files").css("cursor", "pointer");
        } else {
            $(".download_all_files").css("cursor", "default");
        }
    });

    jQuery(".download_all_files").on("click", function () {
        var checked = [];
        var flag = 0;
        $('.file_check').each(function () {
            if ($(this).prop("checked")) {
                flag = 1;
                if ($(this).parent().find('a').attr('href'))
                    checked.push($(this).parent().find('a').attr('href'));
            }
        });
        var file_name = jQuery('.main-contents').attr('data-attr');
        if (flag) {
            jQuery.ajax({
                type: "POST",
                url: '/download_zip_docs',
                data: { files: checked, file_name: file_name },
                dataType: 'json',
                success: function (data) {
                    window.location = data.zip_name;
                },
                error: function () {
                    //Do nothing
                }
            });
        }

    });     
    //  onpage loag deselect all checkboxes
    window.onload = function(){
        var checkboxes = document.getElementsByTagName("input");
     
        for(var x=0; x<checkboxes.length; x++)
        {
           if(checkboxes[x].type == "checkbox")
           {
               checkboxes[x].checked = false;
           }
        }
     
     }

    $('#searchform .search-input').focus(function(){
      $(this).attr('placeholder', '');
    });
    $('#searchform .search-input').focusout(function(){
      $(this).attr('placeholder', 'Search');
    });
     
})(jQuery, Drupal);